<template>
    <div class="main-content-form">
        <div class="right-content">
            <el-card class="box-card" style="padding-top: 10px;">
                <el-form ref="dataForm"
                         label-width="160px" class="two-item-form detail-form">
                    <h3 class="form-header" id="basicInfo">
                        基本信息
                        <span v-if="detailInfo.verifyStatus==1"
                              style="padding-left:15px;color: green;font-size: 10px">已认证</span>
                        <span v-else style="padding-left:15px;color: red;font-size: 10px">未认证</span>
                        <el-button type="text" class="pull-right text-button" @click="editAppHandler">编辑</el-button>
                    </h3>
                    <el-divider></el-divider>
                    <el-form-item label="用户名:" class="single-item">
                        <span>{{detailInfo.userName }}</span>
                    </el-form-item>
                    <el-form-item label="真实姓名:" class="single-item">
                        <span>{{detailInfo.realName}}</span>
                    </el-form-item>
                    <el-form-item label="身份证编号:" class="single-item">
                        <span>{{detailInfo.idNo}}</span>
                    </el-form-item>
                    <el-form-item label="手机号码:" class="single-item">
                        <span>{{detailInfo.mobile}} <el-link type="info" @click="resetMobile">重置手机号码</el-link></span>
                    </el-form-item>
                    <el-form-item label="邮箱地址:" class="single-item">
                        <span>{{detailInfo.email}}</span>
                    </el-form-item>

                    <h3 class="form-header" v-if="detailInfo.traddingOrgId || detailInfo.orgId">
                        交易中心
                    </h3>
                    <el-divider></el-divider>
                    <el-form-item label="交易中心名称:" v-if="detailInfo.traddingOrgId || detailInfo.orgId"
                                  class="single-item">
                        <span>{{getAttributeValue(detailInfo,'traddingOrgId')}}</span>
                    </el-form-item>


                </el-form>
            </el-card>
        </div>
        <div class="left-content">
            <div class="left-navbar">
                <a class="nav-item"><i class="el-icon-caret-left"></i>基本信息</a>

                <el-button type="primary" v-if="detailInfo.status==1" @click="updateStatus(0)">禁用</el-button>
                <el-button type="primary" v-else @click="updateStatus(1)">启用</el-button>

                <el-button @click="resetSecrect">重置密码</el-button>
                <el-button @click="tabsCloseCurrent">返回</el-button>
            </div>
        </div>
        <user-edit-form v-if="addEditDialogVisible" ref="addEditDialog" @refreshDataList="reloadData"></user-edit-form>
    </div>
</template>
<script>
    import UserEditForm from './user_edit'

    export default {
        props: ['mainContentViewHeight'],
        data() {
            return {
                userId: '',
                dataListLoading: false,
                addEditDialogVisible: false,
                detailInfo: {},
            }
        },
        components: {
            UserEditForm
        },
        computed: {
            showConfig: {
                get() {
                    return this.detailInfo !== undefined
                }
            }
        },
        created() {
            this.init(this.$route.params.id)
        },
        methods: {
            getAttributeValue(row, attrName) {
                if (!attrName) {
                    return ''
                }
                if (row.attributes && row.attributes[attrName]) {
                    return row.attributes[attrName]
                }
                return row[attrName]
            },
            reloadData() {
                this.init(this.$route.params.id)
            },
            resetSecrect() {
                let id = this.userId
                this.$http({
                    url: '/auth/sysuser/resetPassword?id=' + id,
                    method: 'post'
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '重置成功',
                            type: 'success',
                            duration: 1500,
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },
            init(id) {
                this.userId = id
                this.$http({
                    url: '/auth/sysuser/getUser?id=' + id,
                    method: 'post'
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.detailInfo = data.data
                    } else {
                        this.detailInfo = {}
                    }
                })
            },
            editAppHandler() {
                this.addEditDialogVisible = true
                this.$nextTick(() => {
                    this.$refs.addEditDialog.init(this.userId)
                })
            },
            resetMobile() {
                /*  this.addEditDialogVisible = true
                  this.$nextTick(() => {
                    this.$refs.addEditDialog.init(this.userId)
                  })*/
            },
            deleteHandle() {
                this.$confirm(`确定要删除该数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        url: this.$http.adornUrl('/auth/employee/delete?ids=' + this.userId),
                        method: 'post',
                    }).then(({data}) => {
                        if (data && data.code === '1') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.tabsCloseCurrent()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            },
            updateStatus(status) {
                let msg = status == 1 ? '确定要启用该数据' : '确定要禁用该数据'
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        url: this.$http.adornUrl('/auth/sysuser/updateStatus?id=' + this.userId + '&status=' + status),
                        method: 'post',
                    }).then(({data}) => {
                        if (data && data.code === '1') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.tabsCloseCurrent()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
</style>
